const RemoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.27509 23.7116C1.68667 23.7458 1.10799 23.5502 0.661067 23.166C-0.220356 22.2793 -0.220356 20.8473 0.661067 19.9606L19.9613 0.660305C20.8781 -0.197536 22.3166 -0.149849 23.1745 0.766908C23.9502 1.59593 23.9954 2.87015 23.2803 3.75202L3.86635 23.166C3.42519 23.5446 2.85579 23.7399 2.27509 23.7116Z"
        fill="white"
      />
      <path
        d="M21.5525 23.7116C20.9562 23.7091 20.3846 23.4724 19.9612 23.0524L0.660883 3.752C-0.155709 2.79841 -0.0446888 1.36331 0.9089 0.54664C1.76 -0.182213 3.01521 -0.182213 3.86624 0.54664L23.2802 19.847C24.1967 20.705 24.2441 22.1437 23.3861 23.0602C23.3519 23.0966 23.3167 23.1319 23.2802 23.166C22.8048 23.5794 22.1792 23.777 21.5525 23.7116Z"
        fill="white"
      />
    </svg>
  );
};
export default RemoveIcon;
